import { render, staticRenderFns } from "./CheckoutCartCrossSellProduct.vue?vue&type=template&id=87198408"
import script from "./CheckoutCartCrossSellProduct.vue?vue&type=script&lang=js"
export * from "./CheckoutCartCrossSellProduct.vue?vue&type=script&lang=js"
import style0 from "./CheckoutCartCrossSellProduct.vue?vue&type=style&index=0&id=87198408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports